import React from 'react';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';

import { AdsContext } from './ads-context';
import { AdsContextV2 } from './ads-context-v2';

export function AdsContextSwitch() {
  return (
    <FeatureFlag name="prebidReactAds">
      {isReactAdsEnabled => (isReactAdsEnabled ? <AdsContextV2 /> : <AdsContext />)}
    </FeatureFlag>
  );
}
